/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrMeasurement, PhrMeasurementFromJSON, PhrMeasurementFromJSONTyped, PhrMeasurementToJSON } from "./";

export const PhrBloodPressureTimesTypename = "PhrBloodPressureTimes" as const;

/**
 *
 * @export
 * @interface PhrBloodPressureTimes
 */
export interface PhrBloodPressureTimes {
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrBloodPressureTimes
   */
  oneTime?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrBloodPressureTimes
   */
  other?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrBloodPressureTimes
   */
  twoTime?: PhrMeasurement;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrBloodPressureTimes
   */
  readonly __typename?: string;
}

export function PhrBloodPressureTimesFromJSON(json: any): PhrBloodPressureTimes {
  return PhrBloodPressureTimesFromJSONTyped(json, false);
}

export function PhrBloodPressureTimesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrBloodPressureTimes {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrBloodPressureTimesTypename,

    oneTime: !exists(json, "one_time") ? undefined : PhrMeasurementFromJSON(json["one_time"]),
    other: !exists(json, "other") ? undefined : PhrMeasurementFromJSON(json["other"]),
    twoTime: !exists(json, "two_time") ? undefined : PhrMeasurementFromJSON(json["two_time"]),
  };
}

export function PhrBloodPressureTimesToJSON(object?: PhrBloodPressureTimes | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    one_time: PhrMeasurementToJSON(value.oneTime),
    other: PhrMeasurementToJSON(value.other),
    two_time: PhrMeasurementToJSON(value.twoTime),
  };
}
